export default class CoreSetting {
  constructor(parent) {
    this.$parent = parent;
    this.data = null;
  }

  get dictionaryExternal() {
    return this.data?.HideExternalDictionaries || false;
  }

  get agreement() {
    return {
      departure: this?.data.DefaultCity,
    };
  }

  set(data) {
    this.data = data || null;
  }

  get(key) {
    return this.data?.[key];
  }
}
